/*
    Create by zhang.yingyu 2018-11-20
*/
'use strict';
angular.module('departSubmitModule', [])
    .controller('departSubmitCtrl', ['$scope', '$q', '$state', '$modalInstance', 'transData', 'trsHttpService', 'trsspliceString', 'modalDialog', 'editIsLock',
        function($scope, $q, $state, $modalInstance, transData, trsHttpService, trsspliceString, modalDialog, editIsLock) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    selectedArray: transData.selectedArray,
                    fusionRouter: { // 融合编辑器路由
                        '1': 'fusionnews',
                        '2': 'fusionatlas',
                        '4': 'fusionlinkdoc',
                        '5': 'fusionactivity',
                        '6': 'fusiontopic',
                        '7': 'fusionvideo',
                        '8': 'fusionlive'
                    },
                    companyList: [],
                    departList: [],
                };
                $scope.status = {
                    title: transData.type === 'manustransmit' ? '稿件传递' : '部门提交',
                    rightTitle: transData.type === 'manustransmit' ? '传递稿件' : '部门提交',
                    isManusTransmit: transData.type === 'manustransmit',
                    selectedCompanyI: 0,
                    selectedDepartI: -1,
                    type: transData.type,
                };
                $scope.departSubmitParams = {
                    serviceid: 'mlf_departoperdoc',
                    methodname: $scope.status.type === 'person' ? 'personalSubmitDepartDoc' : 'receivedSubmitDepartDoc',
                    MetaDataIds: '',
                    DeptDocId: '',
                };
                $scope.manusTransmitParams = {
                    serviceid: 'mlf_departoperdoc',
                    methodname: 'transferDepartDocs',
                    SrcDepartmentaldocId: $state.params.departmentDocId || $state.params.departmentaldocid, // 原部门稿库id
                    TargetDepartmentaldocId: '', // 目标部门稿库id
                    DepartdocrelIds: '',
                };
            }

            /**
             * [initData description]
             * @return {[type]} [description]
             */
            function initData() {
                requestDepartsList();
            }

            /**
             * [iwoDepartSubmit description] 个人稿库部门提交或者传递
             * @return  {[type]}  [return description]
             */
            // function iwoDepartSubmit() {
            //     var defer = $q.defer();
            //     var params = $scope.status.isManusTransmit ? $scope.manusTransmitParams : $scope.departSubmitParams;
            //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            //         defer.resolve(data);
            //     }, function() {
            //         defer.reject();
            //     });
            //     return defer.promise;
            // }

            /**
             * [requestDepartsList description] 初始化部门列表
             * @return  {[type]}  [return description]
             */
            function requestDepartsList() {
                var params = {
                    serviceid: 'mlf_departoperdoc',
                    methodname: 'querySubmitDeptmentalDocs'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.companyList = data;
                    $scope.data.departList = $scope.data.companyList[$scope.status.selectedCompanyI].CHILDREN;
                });
            }

            /**
            * [deleteDepartManus description]
            * @param   {[type]}  index  [index description]
            * @return  {[type]}         [return description]
            */
            $scope.deleteDepartManus = function(index) {
                modalDialog.alertType('删除成功', '', 'success', false, function() {
                    $scope.data.selectedArray.splice(index, 1);
                    if ($scope.data.selectedArray.length === 0) {
                        $modalInstance.dismiss('error');
                    } else {
                        return;
                    }
                });
            };

            /**
             * [getCompanyData description]
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            $scope.getCompanyData = function(item, index) {
                $scope.status.selectedCompanyI = index;
                $scope.data.departList = $scope.data.companyList[index].CHILDREN;
            };

            /**
             * [getDepartsData description]
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  index  [index description]
             * @return  {[type]}         [return description]
             */
            $scope.getDepartsData = function(item, index) {
                if ($scope.status.selectedDepartI === item.DEPARTMENTALDOCID) {
                    $scope.status.selectedDepartI = -1;
                } else {
                    $scope.status.selectedDepartI = item.DEPARTMENTALDOCID;
                }
                if ($scope.status.isManusTransmit) {
                    $scope.manusTransmitParams.TargetDepartmentaldocId = $scope.data.departList[index].DEPARTMENTALDOCID;
                } else {
                    $scope.departSubmitParams.DeptDocId = $scope.data.departList[index].DEPARTMENTALDOCID;
                }
            };

            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                if ($scope.status.isManusTransmit) {
                    if ($scope.manusTransmitParams.TargetDepartmentaldocId === $scope.manusTransmitParams.SrcDepartmentaldocId) {
                        modalDialog.alertType('不能选择自己所在的部门稿库', '', 'warning', false, function() {});
                        return;
                    }
                    $scope.manusTransmitParams.DepartdocrelIds = trsspliceString.spliceString($scope.data.selectedArray, 'DEPARTDOCRELID', ',');
                } else {
                    $scope.departSubmitParams.MetaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
                }
                if ($scope.status.selectedDepartI < 0) {
                    modalDialog.alertType('请选择部门稿库', '', 'warning', false, function() {});
                    return;
                }
                var params = $scope.status.isManusTransmit ? $scope.manusTransmitParams : $scope.departSubmitParams;
                if (!$state.params.iwometadataid){
                    $modalInstance.close(params);
                } else {
                    editIsLock.normalLock($state.params.iwometadataid).then(() => {
                        $modalInstance.close(params);
                    });
                }
            };

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
